import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Actions, Services, Selectors
import * as actions from 'actions';
import { currentUserSelector } from 'selectors';
import { isRegistered } from 'services/userInfoService';

import AuthHeaderLink from 'Components/Auth/AuthHeaderLink';

import { FORM_KEYS } from 'Components/Auth/AuthModal';

// External components
import { Button } from 'react-bootstrap';

class AuthNavWrapper extends Component {
  renderLogout = () => {
    return (
      <Button bsStyle={'link'} onClick={this.props.logout}>
        Log out
      </Button>
    );
  };

  renderLogInAndRegisterNavs = () => {
    return (
      <React.Fragment>
        <AuthHeaderLink text="Log In" formToDisplay={FORM_KEYS.login} />
        <AuthHeaderLink text="Sign Up" formToDisplay={FORM_KEYS.registration} />
      </React.Fragment>
    );
  };

  render() {
    const { user, className } = this.props;
    let buttons;
    if (isRegistered(user)) {
      buttons = this.renderLogout();
    } else {
      buttons = this.renderLogInAndRegisterNavs();
    }
    return (
      <div className={`AuthNavWrapper ${className ? className : ''}`}>
        {buttons}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state.auth,
    user: currentUserSelector(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout: actions.logout,
    },
    dispatch
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(AuthNavWrapper);



// WEBPACK FOOTER //
// ./src/Components/Layout/AuthNavWrapper.js